import { IRootState } from '../../../store'
import { ICcHpiCardiacArrestState } from '../store/ccHpi.types'

export const getCardiacArrestSelector = (state: IRootState): ICcHpiCardiacArrestState => state.ccHpiCardiacArrest
